function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2021, 2024. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 */
import React, { useContext, useEffect, useState } from "react";
import { isEqual } from "lodash";
import { SidePanel, SidePanelContainer } from "@console/cloud-pal-community/components/Basic";
import { InlineNotification, Toggle, Tooltip } from "@carbon/react";
import { Information } from "@carbon/react/icons";
import { PANEL_MODE_ADD, PROP_APPCONFIG, PROP_ENUM, PROP_INTEGRATION, PROP_SECURE, PROP_TEXT, PROP_TEXTAREA, REQUIRED_KEY_FORMAT } from "../Constants";
import { i18nContext } from "../table-context";
import AppConfigContent from "./AppConfigContent";
import CustomTextInput from "./CustomTextInput";
import EnumContent from "./EnumContent";
import IntegrationContent from "./IntegrationContent";
import SecureContent from "./SecureContent";
import TextContent from "./TextContent";
var propertyComponents = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, PROP_APPCONFIG, AppConfigContent), PROP_ENUM, EnumContent), PROP_INTEGRATION, IntegrationContent), PROP_SECURE, SecureContent), PROP_TEXT, TextContent), PROP_TEXTAREA, TextContent);
function PropertySidePanel(_ref) {
  var _editingProperty$inde;
  var error = _ref.error,
    handleChange = _ref.handleChange,
    handleClose = _ref.handleClose,
    isLoadingToolchainServices = _ref.isLoadingToolchainServices,
    lang = _ref.lang,
    mode = _ref.mode,
    onCloseErrorNotification = _ref.onCloseErrorNotification,
    property = _ref.property,
    _ref$propNames = _ref.propNames,
    propNames = _ref$propNames === void 0 ? [] : _ref$propNames,
    showDiscardModal = _ref.showDiscardModal,
    showLock = _ref.showLock;
  var _useState = useState(property),
    _useState2 = _slicedToArray(_useState, 2),
    editingProperty = _useState2[0],
    setEditingProperty = _useState2[1];
  var _useState3 = useState(mode === PANEL_MODE_ADD),
    _useState4 = _slicedToArray(_useState3, 2),
    isNew = _useState4[0],
    setIsNew = _useState4[1];
  var _useState5 = useState({
      name: mode === PANEL_MODE_ADD
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    validationErrors = _useState6[0],
    setValidationErrors = _useState6[1];
  var i18n = useContext(i18nContext);
  var validateName = function validateName() {
    var name = editingProperty.name;
    if (!name) {
      return i18n.messages.errorPropertyEmptyName;
    }
    var isValidFormat = REQUIRED_KEY_FORMAT.test(name);
    if (!isValidFormat) {
      return i18n.messages.errorPropertyInvalidKey;
    }
    var isDuplicate = name !== property.name && !!propNames.filter(function (prop) {
      return prop === name;
    }).length;
    if (isDuplicate) {
      return i18n.messages.errorPropertyDuplicate;
    }
    return null;
  };
  var validate = function validate(field, validator) {
    setValidationErrors(function (errors) {
      return _objectSpread(_objectSpread({}, errors), {}, _defineProperty({}, field, validator()));
    });
  };
  useEffect(function () {
    isNew && setIsNew(false);
    !isNew && validate("name", validateName);
  }, [editingProperty.name]);
  var handleClosePanel = function handleClosePanel() {
    var isChanged = !isEqual(editingProperty, property);
    if (isChanged) {
      showDiscardModal(true);
    } else {
      handleClose();
    }
  };
  var PropertyComponent = propertyComponents[property === null || property === void 0 ? void 0 : property.type.toUpperCase()] || React.Fragment;
  return /*#__PURE__*/React.createElement(SidePanelContainer, {
    doneText: mode === PANEL_MODE_ADD ? i18n.messages.propertyAdd : i18n.messages.save,
    isOpen: true,
    locale: lang,
    onCloseClick: function onCloseClick() {
      return handleClosePanel();
    },
    onCancelClick: function onCancelClick() {
      return handleClosePanel();
    },
    onDoneClick: function onDoneClick() {
      handleChange(editingProperty);
      // return false to prevent PAL auto-closing the SidePanel, we'll handle
      // it ourselves so we can wait for API response.
      return false;
    },
    panelSize: "medium"
  }, /*#__PURE__*/React.createElement(SidePanel, {
    className: "ocr--property-edit",
    closePanelText: i18n.messages.closePanel,
    id: "ocr--property-edit",
    primaryButtonDisabled: Object.keys(validationErrors).some(function (key) {
      return validationErrors[key];
    }),
    title: mode === PANEL_MODE_ADD ? i18n.messages.propertyAddTitle : i18n.messages.propertyEditTitle
  }, /*#__PURE__*/React.createElement(CustomTextInput, {
    "aria-label": i18n.messages.propertyName,
    autoComplete: "off",
    id: "property-".concat((_editingProperty$inde = editingProperty.index) !== null && _editingProperty$inde !== void 0 ? _editingProperty$inde : "new"),
    invalid: !isNew && validationErrors.name && validationErrors.name !== true,
    invalidText: validationErrors.name,
    isDirty: false,
    labelText: i18n.messages.propertyName,
    onChange: function onChange(newValue) {
      setEditingProperty(function (currentProperty) {
        return _objectSpread(_objectSpread({}, currentProperty), {}, {
          name: newValue
        });
      });
    },
    placeholder: i18n.messages.propertyName,
    spellCheck: "false",
    type: "text",
    value: editingProperty.name
  }), showLock ? /*#__PURE__*/React.createElement("div", {
    className: "ocr--toggle-section"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ocr--toggle-section-block"
  }, /*#__PURE__*/React.createElement(Toggle, {
    id: "ocr--property-edit-prevent-override",
    labelText: i18n.messages.propertyLocked,
    labelA: i18n.messages.toggleOff,
    labelB: i18n.messages.toggleOn,
    onToggle: function onToggle(locked) {
      setEditingProperty(function (currentProperty) {
        return _objectSpread(_objectSpread({}, currentProperty), {}, {
          locked: locked
        });
      });
    },
    toggled: editingProperty.locked
  }), /*#__PURE__*/React.createElement("span", {
    className: "ocr--toggle-locked-tooltip"
  }, /*#__PURE__*/React.createElement(Tooltip, {
    align: "bottom-left",
    label: i18n.messages.propertyLockedTooltip
  }, /*#__PURE__*/React.createElement("button", {
    className: "ocr--tooltip-trigger",
    type: "button"
  }, /*#__PURE__*/React.createElement(Information, null)))))) : null, /*#__PURE__*/React.createElement(PropertyComponent, {
    isLoadingToolchainServices: isLoadingToolchainServices,
    isNew: mode === PANEL_MODE_ADD,
    property: editingProperty,
    setValidationError: validate,
    updateProperty: setEditingProperty,
    validationErrors: validationErrors
  }), error && /*#__PURE__*/React.createElement(InlineNotification, {
    kind: "error",
    lowContrast: true,
    title: i18n.messages.errorPropertySave,
    subtitle: error.description || error.message,
    iconDescription: i18n.messages.close,
    onCloseButtonClick: onCloseErrorNotification
  })));
}
export default PropertySidePanel;